module.exports = __webpack_public_path__ + "static/media/comments-icon.a385ff34.svg";